export default "__VITE_ASSET__BiS_LG_F__"